import { Component } from '@angular/core';
import { TabsService } from 'src/app/libs/components/tabs-host/tabs.service';

@Component({
    selector: 'app-common',
    templateUrl: './common.component.html',
    styleUrls: ['./common.component.sass'],
    standalone: false
})
export class CommonComponent {
  tabs = this.tabsSrv.tabs;

  constructor(private tabsSrv: TabsService) {}
}
